import { colors } from "./colors";


import addonHeadersPassingImage from '../assets/images/addons/rezzil-headers-passing.png';
import addonReactionWallImage from '../assets/images/addons/rezzil-reaction-wall.png';
import addonVolleysImage from '../assets/images/addons/rezzil-volleys.png';
import addonBoardTestImage from '../assets/images/addons/rezzil-board-test.png';

import addonHeadersBundleImage from '../assets/images/addons/rezzil-headers-bundle.png';
import addonProBundleImage from '../assets/images/addons/rezzil-pro-bundle.png';
import addonHeadersControlImage from '../assets/images/addons/addon-12.png';
import addonHeadersClearingImage from '../assets/images/addons/addon-13.png';

import addonHeadersShootingImage from '../assets/images/addons/addon-15.png';

import addonHeartRateImage from '../assets/images/addons/addon-21.png';
import addonBrandPackImage from '../assets/images/addons/brand_addon.png';


export const addonOptions = [
  {
    id: 0,
    title: "Headers - Control",
    name: "addon_headers_control",
    type: 'individual',
    image: addonHeadersControlImage,
    description: "Headers control is designed to perfect your ability to manipulate the direction of the ball. Aim for the centre of the hoops to score more points.",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "15",
    yearlyPersonalPrice: "150",
  },
  {
    id: 1,
    title: "Headers - Shooting",
    name: "addon_headers_shooting",
    type: 'individual',
    image: addonHeadersShootingImage,
    description: "The shooting drill is designed to test and develop your finshing ability infront of goal. This drill will develop an accurate and powerful finish.",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "15",
    yearlyPersonalPrice: "150",
  },
  {
    id: 2,
    title: "Headers - Clearing",
    name: "addon_headers_clearing",
    type: 'individual',
    image: addonHeadersClearingImage,
    description: "Headers clearing is designed to develop your defensive skills in a safe enviornment. For this drill, your feet and body position to head the ball are important.",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "15",
    yearlyPersonalPrice: "150",
  },
  {
    id: 3,
    title: "Headers - Passing",
    name: "addon_headers_passing",
    type: 'individual',
    image: addonHeadersPassingImage,
    description: "Headers passing is designed to improve your ability to accurately deliver a ball to a team mate. This drill is all about controlled handling of the ball.",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "15",
    yearlyPersonalPrice: "150",
  }, {
    id: 4,
    title: "Reaction Wall",
    name: "addon_reaction_wall",
    type: 'individual',
    image: addonReactionWallImage,
    description: "The reaction wall puts your reaction time, and hand eye coordination to the test. Touch as many lights that appear on the wall before the time runs out.",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "10",
    yearlyPersonalPrice: "100",
  }, {
    id: 5,
    title: "Volleys",
    name: "addon_volley_rehab",
    type: 'individual',
    image: addonVolleysImage,
    description: "For this drill, just pass the oncoming ball back into the hoop. Try a variety of passes such as a simple volley, half volley, or laces.",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "15",
    yearlyPersonalPrice: "150",
  }, {
    id: 6,
    title: "Board Test",
    name: "addon_board_test",
    type: 'individual',
    image: addonBoardTestImage,
    description: "The Rezzil board test is a passing drill designed to test your ability to pass and control the ball. Pass the ball between the two boards as many times as you can before the time runs out.",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "15",
    yearlyPersonalPrice: "150",
  },
  {
    id: 7,
    title: "Heart Rate",
    name: "addon_heart_rate",
    type: 'individual',
    image: addonHeartRateImage,
    description: "A heart rate monitor is an electronic device designed to measure your heart rate during physical activity. You can monitor and measure your heart rate while playing the rezzil activites.",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "15",
    yearlyPersonalPrice: "150",
  },/*
  {
    id: 8,
    title: "Shot Stopper",
    name: "addon_shot_stopper",
    type: 'individual',
    image: addonHeartRateImage,
    description: "",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "15",
    yearlyPersonalPrice: "150",
  },

  {
    id: 9,
    title: "Darts",
    name: "addon_darts",
    type: 'individual',
    image: addonHeartRateImage,
    description: "",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "15",
    yearlyPersonalPrice: "150",
  },
  {
    id: 10,
    title: "Golf",
    name: "addon_golf",
    type: 'individual',
    image: addonHeartRateImage,
    description: "",
    monthlyClubPrice: "15",
    yearlyClubPrice: "150",
    monthlyPersonalPrice: "15",
    yearlyPersonalPrice: "150",
  },*/
  {
    id: 12,
    title: "Brand Pack",
    name: "addon_brand_pack",
    type: 'individual',
    image: addonBrandPackImage,
    description: "Customise the environments with your own branding or adverts.",
    monthlyClubPrice: "100",
    yearlyClubPrice: "1000",
    monthlyPersonalPrice: null,
    yearlyPersonalPrice: null,
  }, {
    id: 13,
    title: "Headers Bundle",
    name: "addon_headers_bundle",
    type: 'bundle',
    image: addonHeadersBundleImage,
    description: "Get all header drills at a discount",
    addons: [0, 1, 2, 3],
    monthlyClubPrice: "40",
    yearlyClubPrice: "400",
    monthlyPersonalPrice: "40",
    yearlyPersonalPrice: "400",
  }, {
    id: 14,
    title: "Pro Bundle",
    name: "addon_pro_bundle",
    type: 'bundle',
    image: addonProBundleImage,
    description: "Gell all drills at a discount",
    addons: [0, 1, 2, 3, 4, 5, 6, 7, 8],
    monthlyClubPrice: "70",
    yearlyClubPrice: "700",
    monthlyPersonalPrice: "70",
    yearlyPersonalPrice: "700",
  },
];

export const addonTabs = [
  {
    id: 'individual',
    value: 'individual',
    label: 'Individual'
  }, {
    id: 'bundle',
    value: 'bundle',
    label: 'Bundles'
  }
];

export const getOptionByName = (name) =>
{
  let out = addonOptions.filter((e) => { return name === e.name });
  if (out.length === 1) { return out[0] };
  return false;

}
